import { render, staticRenderFns } from "./emailVerify.vue?vue&type=template&id=0e4054e6&scoped=true&"
import script from "./emailVerify.vue?vue&type=script&lang=js&"
export * from "./emailVerify.vue?vue&type=script&lang=js&"
import style0 from "./emailVerify.vue?vue&type=style&index=0&id=0e4054e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4054e6",
  null
  
)

export default component.exports